import { Controller, FieldValues, UseFormReturn } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { Select } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { useSelect, useUserRoles } from 'shared/hooks'
import type { Country } from 'shared/types/general.types'
import { toOptions } from '../../utils/options'

type LegalFieldsProps = {
	form: UseFormReturn<FieldValues>
	countries: Country[] | undefined
	isCountriesLoading: boolean
}

export const LegalFields = ({ form, countries, isCountriesLoading }: LegalFieldsProps) => {
	const { t } = useTranslation()
	const {
		register,
		control,
		setValue,
		trigger,
		formState: { errors }
	} = form
	const { handleSelectChange } = useSelect({ setValue, trigger })
	const { isAdmin, isSuperuser } = useUserRoles()
	const fieldErrors = errors as any

	return (
		<>
			<InputGroup id="legal_name" label={t('Legal name')} {...register('legal_name')} />
			<InputGroup id="legal_id" label={t('Legal id')} {...register('legal_id')} />
			<InputGroup
				id="legal_address"
				label={t('Legal address')}
				required
				{...register('legal_address.address')}
				error={fieldErrors.legal_address?.address}
			/>
			<div className="grid gap-4 sm:grid-cols-2">
				<InputGroup
					id="legal_postal_code"
					label={t('Legal postal code')}
					required
					{...register('legal_address.postal_code')}
					error={fieldErrors.legal_address?.postal_code}
				/>
				<InputGroup
					id="legal_city"
					label={t('Legal city')}
					required
					{...register('legal_address.city')}
					error={fieldErrors.legal_address?.city}
				/>
			</div>
			<Controller
				name="legal_country"
				control={control}
				render={({ field }) => (
					<Select
						id="legal_country"
						variant="form"
						isClearable={false}
						isSearchable
						label={t('Legal country')}
						required
						options={toOptions(countries)}
						{...field}
						isLoading={isCountriesLoading}
						error={fieldErrors.legal_country?.value}
						onChange={(data: any) =>
							handleSelectChange({ id: 'legal_country', value: data?.value, label: data?.label })
						}
					/>
				)}
			/>
			<InputGroup
				id="terms_of_service_url"
				type="url"
				label={t('Terms of service url')}
				disabled={!isAdmin && !isSuperuser}
				{...register('terms_of_service_url')}
				error={fieldErrors.terms_of_service_url}
			/>
		</>
	)
}
